import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getPortadoresQuitacaoFluxo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/listarPorTipoInstituicaoFluxo', dados, {timeout:60000});
        if (!Array.isArray(data)) throw new Error('Não foi possível consultar os portadores. Tente novamente.');
        return data;
    },
	getPortadores(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("portadores/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
	getPortadoresBox(context, dados) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
					ApiService.setHeader();
					ApiService.post("portadores/access/listaBox", dados).then(({ data }) => {
							resolve(data);
					});
				}
		});
	},
	async getPortadoresPorTipoInstituicaoConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/listarPorTipoInstituicaoContaPaciente', dados, {timeout:60000});
        if (!Array.isArray(data)) throw new Error('Não foi possível consultar os portadores. Tente novamente.');
        return data;
    },
	async getPortadoresBandeiras(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/listaBoxAdquirenteBandeiras', dados, {timeout:60000});
        if (!Array.isArray(data)) throw new Error('Não foi possível consultar os portadores. Tente novamente.');
        return data;
    },
    async getPortadoresBandeirasDistinct(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/listaBoxAdquirenteBandeirasDistinct', dados, {timeout:60000});
        if (!Array.isArray(data)) throw new Error('Não foi possível consultar os dados do portador.');
        return data;
    },
	getPortadoresMaquininhas(context, dados){
		return new Promise(resolve => {
			if (JwtService.getToken()) {
					ApiService.setHeader();
					ApiService.post("portadores/access/listaBoxAdquirentMaquininhas", dados).then(({ data }) => {
							resolve(data);
					});
				}
		});
	},
    async getPortadoresBandeirasTipoPgto(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/listaBoxAdquirenteBandeirasTpPgto', dados, {timeout:60000});
        if (!Array.isArray(data)) throw new Error('Não foi possível consultar os dados do portador.');
        return data;
    },
    async getPortadoresTaxa(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('portadores/access/obterPortadorTaxa', dados, {timeout:60000});
        if (!data?.ID_PORTADORE_MP_TAXA) throw new Error('Não foi possível consultar os dados do portador.');
        return data;
    },
	postPortador(context, dados) {
		return new Promise(resolve => {
			if(JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("portadores/access/salvar", dados).then(({ data }) => {
					resolve(data);
				});
			}
		});
	},
	postPortadorSimples(context, dados) {
		return new Promise(resolve => {
			if(JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("portadores/access/salvarSimples", dados).then(({ data }) => {
					resolve(data);
				});
			}
		});
	},
	getPortador(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("portadores/access/obterPortador", {ID_PORTADOR: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
	getPortadorSimples(context, idPortador) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("portadores/access/obterSimples", idPortador).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },	
	deletePortador(context, dados) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("portadores/access/excluir", { ID_PORTADOR: dados.id, componente: dados.componente }).then(({ data }) => {
					resolve(data);
				});
			}
		});
	}, 
	getPortadorUsuarios(context, idEmpresa) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("portadores/access/obterUsuarios", idEmpresa).then(({ data }) => {
					resolve(data);
				});
			}
		});
	}
};

export default {
    state,
    actions,
    mutations,
    getters
};